var App = App || {};

App.OnlineBanking = (function ($) {
    'use strict';

    var olbAreas = $(".onlinebanking");

    var $type = $('.onlinebanking .online-banking-type-selector'),
        loginModalSettings = $('.onlinebanking').data('modals'),
        $loginModal = $('#loginModal');

    function init() {
        $type.change(function () {
            var olbArea = $(this).closest(".onlinebanking");
            if (!$(this).find("option[value='" + $(this).val() + "']").data("form")) { //if there's no associated form
                ShowGo(olbArea);
                updateGoButton(olbArea);
            }
            else { //if this option has an associated form
                HideInnerTop(olbArea); //make room for the form
                $($(this).val()).removeClass('d-none'); //show it
            }
        });

        $(".olb-go").on("click", function () {
            //if there's an associated olb speedbump modal active, set content (modal functionality handled in Speedbump.js)
            for (var i in loginModalSettings) {
                if (loginModalSettings[i].MappingHtmlId == $(".olb-go").data("option-id") && loginModalSettings[i].IsEnabled) {
                    $loginModal.find('.modal-title').html(loginModalSettings[i].Title);
                    $loginModal.find('.modal-body').html(loginModalSettings[i].Content);
                }
            }
        });

        $(".olb-back").on("click", function () { //set olb menu to default view
            var olbArea = $(this).closest(".onlinebanking");
            var type = olbArea.find(".online-banking-type-selector");
            ShowInnerTop(olbArea);
            if (type.find("option[value='" + type.val() + "']").data("form")) {
                type.val(type.find("option:eq(0)").val());
            }
            updateGoButton(olbArea);
            olbArea.find(".onlinebanking-top-logintype.radio").focus();
        });

        $('.onlinebanking input.OlbRadio').change(function () { //personal/business form toggle
            $(this).closest(".onlinebanking").find(".pb-panel").addClass('d-none');
            $($(this).val()).removeClass('d-none');
        });

        SetupOnlineBankingPanels();
        olbAreas.each(function () {
            updateGoButton($(this));
        });
    }
    function updateGoButton(olbArea) { //ensure olb-go button has all the proper attributes for the selected option
        var type = olbArea.find(".online-banking-type-selector");
        var olbGo = olbArea.find(".olb-go");
        olbArea.data("option-id", type.find("option[value='" + type.val() + "']").data("option-id"));
        olbGo.attr("href", type.val());
        if (type.find("option[value='" + type.val() + "']").data("show-modal") == "true") {
            olbGo.addClass("show-login-modal");
        }
        else {
            olbGo.removeClass("show-login-modal");
        }
    }
    function HideInnerTop(olbArea) { //make room for the "another account" form
        olbArea.find(".onlinebanking-top").addClass('d-none');
        olbArea.find(".olb-back").removeClass('d-none');
        olbArea.find(".other-panel").addClass('d-none');
        HideGo(olbArea);
    }
    function ShowInnerTop(olbArea) { //undo the "another account" form changes
        olbArea.find(".onlinebanking-top").removeClass('d-none');
        olbArea.find(".olb-back").addClass('d-none');
        ShowGo(olbArea);
    }
    function ShowGo(olbArea) { //show go button, hide "another account" forms
        olbArea.find(".other-panel").addClass('d-none');
        olbArea.find(".olb-type-container").removeClass("sans-go").addClass("has-go");
        olbArea.find(".olb-go").removeClass('d-none');
    }
    function HideGo(olbArea) { //hide go button
        olbArea.find(".olb-type-container").removeClass("has-go").addClass("sans-go");
        olbArea.find(".olb-go").attr("href", "javascript:void(0)").addClass('d-none');
    }

    function SetupOnlineBankingPanels() {
        $.each(loginModalSettings, function (index, loginTypeSettings) {
            if (loginTypeSettings.IsEnabled) {
                var $loginTypeContainer = $('.onlinebanking #' + loginTypeSettings.MappingHtmlId);
                var $parentForm = $loginTypeContainer.find('form');
                var $loginFormButton = $loginTypeContainer.find('.olb-submit');

                $(".online-banking-type-selector option").each(function (index) {
                    if (loginTypeSettings.MappingHtmlId == $(this).data("option-id")) { //if this modal has an associated olb drop-down option
                        $(this).data("show-modal", "true"); //true value is used to show modal when olb-go button is clicked
                    }
                });

                if ($parentForm.length > 0) {
                    // Prevent immediate submission and wait until modal's continue button is pressed to submit the form.
                    $loginFormButton.on('click', function (e) {
                        if ($parentForm[0].checkValidity()) {
                            $loginModal.find('.modal-title').html(loginTypeSettings.Title);
                            $loginModal.find('.modal-body').html(loginTypeSettings.Content);
                            $loginModal.find('#loginModalSubmit')
                                .attr('href', 'javascript:void(0);')
                                .attr('target', '')
                                .off('click.loginmodalsubmit')
                                .on('click.loginmodalsubmit', function () {
                                    $parentForm.submit(); // Submit the form when Modal Continue button is pressed.
                                    $loginModal.modal('hide');
                                });

                            $loginModal.modal('show');
                        } else {
                            return true;  //submit invalid form to display browsers' native validity error
                        }

                        return false; // Prevent immediate submission.
                    });
                }
                else {
                    /* For standalong anchors, decorate and let the Speedbump app control the functionality as 
                     * Speedbump logic still needs to be supported. */
                    $loginFormButton
                        .data('loginmodaltitle', loginTypeSettings.Title)
                        .data('loginmodalcontent', loginTypeSettings.Content)
                        .addClass('show-login-modal');
                }
            }
        });

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.OnlineBanking.init();
});